import React, { Component } from 'react';
import propTypes from 'prop-types';
import { ButtonWaitingPromise } from 'client/components/Button/ButtonWaiting';

export default class FSTDPanel extends Component {

  static propTypes = {
    onCall: propTypes.func.isRequired,
  };

  render () {
    const { onCall } = this.props;
    return (
      <div>
        <div>
          <ButtonWaitingPromise onClick={ev => onCall('importOneInstance')} type="button" className="btn btn-default">
            Run Import
          </ButtonWaitingPromise>{' '}
        </div>
      </div>
    );
  }

}
